// Copyright (c) 2016 Deere & Company

import t from 'tcomb';

const SecurityModuleFeature = t.struct({
    feature: t.String,
    isAllowed: t.Bool
}, {
    name: 'SecurityModuleFeature',
    strict: true
});

export const getDefaultState = () => new SecurityModuleFeature({
    feature: '',
    isAllowed: false
});

export default SecurityModuleFeature;



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-model-factory/lib/security-module-feature.js